// extracted by mini-css-extract-plugin
export default {"container":"_2WovNg4A","svg":"_2ZHKCUmM","text":"_15uHLUai"};